import { FORMAT_TYPE } from "../../../data/variables";

export const DYNAMIC_DATA = {
  'idle-stops': {
    arrayPath: 'idle_times',
    period: {
      from: 'start_date',
      to: 'end_date'
    },
    dataPath: 'idle_time'
  },
  'weekly-hours': {
    arrayPath: 'overview',
    period: {
      from: 'start_date',
      to: 'end_date'
    },
    dataPath: 'range_total',
    week: {
      period: {
        from: 'date'
      },
      format: FORMAT_TYPE.NONE
    }
  },
  'vehicle-distance': {
    arrayPath: 'overview',
    period: {
      from: 'start_date',
      to: 'end_date'
    },
    dataPath: 'odometer',
    week: {
      period: {
        from: 'date'
      },
    }
  }
}
